import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { api } from '@/lib/api'
import { getDashboardDefaultPath } from '@/lib/dashboard-shell'
import { Navigate } from '@tanstack/react-router'
import { LockKeyhole } from 'lucide-react'
import { useState } from 'react'

export function LegacySuperLoginRedirect() {
  return <Navigate to="/login-super" replace />
}

export default function LoginSuperRoute() {
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  async function submit() {
    setIsSubmitting(true)
    setError('')
    try {
      const sessionUser = await api.superAdminLogin({ account, password })
      window.location.href = getDashboardDefaultPath(sessionUser)
    } catch {
      setError('超級管理員帳號或密碼不正確，或 server env 尚未設定。')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <main className="grid min-h-screen place-items-center bg-slate-950 p-6">
      <section className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="grid size-11 place-items-center rounded-lg bg-indigo-600 text-white">
            <LockKeyhole className="size-5" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-slate-950">超級管理員登入</h1>
            <p className="mt-1 text-sm text-slate-500">
              由 server env 驗證帳號與密碼，不使用 Google 帳號比對。
            </p>
          </div>
        </div>
        <div className="mt-6 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="super-account">超級管理員帳號</Label>
            <Input
              id="super-account"
              type="text"
              value={account}
              onChange={(event) => setAccount(event.currentTarget.value)}
              autoComplete="username"
              placeholder="輸入 SUPER_ADMIN_ACCOUNT"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="super-password">密碼</Label>
            <Input
              id="super-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.currentTarget.value)}
              autoComplete="current-password"
              placeholder="輸入 SUPER_ADMIN_PASSWORD"
            />
          </div>
          {error ? (
            <div className="rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">
              {error}
            </div>
          ) : null}
          <Button type="button" className="w-full" onClick={submit} disabled={isSubmitting}>
            登入超級管理員
          </Button>
        </div>
      </section>
    </main>
  )
}
